import {
  AddIcon,
  ArrowDownIcon,
  ChevronDownIcon,
  EditIcon,
  ExternalLinkIcon,
  HamburgerIcon,
  RepeatIcon,
} from '@chakra-ui/icons';
import {
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import store from '../redux/store';
import '../pages/Game/all.css';
import '../pages/Game/game.css';
import AsyncSelect from 'react-select/async';
import {
  getUserDataAPI,
  getUserDetailsAPI,
  searchUserAPI,
} from '../service/AuthService';
export default function Header({ drawerButtonRef, onOpen }) {
  const [userName, setUserName] = React.useState('');
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [userDetails, setUserDetails] = React.useState({});
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const toast = useToast();

  const searchClient = (inputValue) => {
    return searchUserAPI(inputValue)
      .then((response) => {
        return response.response.map((userName) => ({
          value: userName,
          label: userName,
        }));
      })
      .catch((error) => {
        // dispatch({
        //   type: 'accountData/logOut',
        //   payload: {},
        // });
        // window.localStorage.clear();
        // window.location.href = '/';
        console.error('searchUserAPI error:', error);
      });
  };
  const getUserDetail = async (userName) => {
    const { response, message, code } = await getUserDetailsAPI(userName);
    if (code == 200) {
      setIsModalOpen(true);
      setUserDetails(response);
    } else {
      toast({
        title: 'Error',
        description: response,
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };
  const getAccountDetails = async () => {
    const { response } = await getUserDataAPI(
      store.getState().account.userData.id
    );
  };
  useEffect(() => {
    setUserName(store.getState().account.userData.username);
    const interval = setInterval(() => {
      getAccountDetails();
    }, 5000);
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      clearInterval(interval);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <header>
      <div class='header-bottom'>
        <div class='container-fluid admin-header-cf'>
          {/* Logo + hamburger: only visible on mobile, handled by sidebar on desktop */}
          <a href='/admin' className='logo admin-logo mobile-only'>
            <img
              src={require('../assets/img/logo-white.png')}
              alt=''
              className='admin-logo-img'
            />
          </a>
          <div
            ref={drawerButtonRef}
            className='side-menu-button admin-hamburger mobile-only'
            onClick={onOpen}
          >
            <div className='bar1'></div>
            <div className='bar2'></div>
            <div className='bar3'></div>
          </div>


          <Modal
            scrollBehavior='outside'
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
            }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Modal Title</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <div
                  className='modal fade show'
                  id='modal-user-detail'
                  style={{ display: 'block' }}
                >
                  <div className='modal-dialog modal-lg'>
                    <div
                      style={{
                        overflowY: 'auto',
                        height: '80vh',
                      }}
                      className='modal-content'
                    >
                      <div className='modal-header'>
                        <h4 className='modal-title'>User Detail</h4>
                        <button
                          type='button'
                          className='close'
                          data-dismiss='modal'
                          onClick={() => {
                            setIsModalOpen(false);
                          }}
                        >
                          ×
                        </button>
                      </div>
                      <div className='modal-body dark' id='search-user-details'>
                        <div className='row'>
                          <div className='col-md-6 m-t-10'>
                            <h4 className='m-b-10 col-md-12'>Game Lock</h4>
                            <table className='table table-striped table-dark'>
                              <thead>
                                <tr>
                                  <th>EventName</th>
                                  <th>UserName</th>
                                  <th>UserActive</th>
                                  <th>BetActive</th>
                                  <th>FancyActive</th>
                                </tr>
                              </thead>
                            </table>
                          </div>
                          <div className='col-md-6 m-t-10'>
                            <h4 className='m-b-10 col-md-12'>User Lock</h4>
                            <table className='table table-striped table-dark'>
                              <thead>
                                <tr>
                                  <th>UserName</th>
                                  <th>AccountType</th>
                                  <th>UserActive</th>
                                  <th>BetActive</th>
                                </tr>
                              </thead>
                              <tbody>
                                {userDetails?.userLockUserDetailsDTOS?.map(
                                  (user) => (
                                    <tr>
                                      {' '}
                                      <td>{user.userName}</td>{' '}
                                      <td>{user.userType}</td>{' '}
                                      <td>
                                        <label className='form-check-label'>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            disabled
                                            defaultChecked='checked'
                                          />
                                          {user.userActive && (
                                            <span className='checkmark' />
                                          )}
                                        </label>
                                      </td>{' '}
                                      <td>
                                        <label className='form-check-label'>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            disabled
                                            defaultChecked='checked'
                                          />
                                          {user.betActive && (
                                            <span className='checkmark' />
                                          )}
                                        </label>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className='col-md-12 m-t-10'>
                            <h4 className='m-b-10 col-md-12'>Game Book</h4>
                            <table className='table table-striped table-dark'>
                              <thead>
                                <tr>
                                  <th>Gametype</th>
                                  <th>EventName</th>
                                  <th>BookA</th>
                                  <th>NationA</th>
                                  <th>BookB</th>
                                  <th>NationB</th>
                                  <th>BookC</th>
                                  <th>NationC</th>
                                  <th>NoOfBet</th>
                                </tr>
                              </thead>
                              <tbody>
                                {userDetails?.gameBookUserDetailsDTOS?.map(
                                  (user) => (
                                    <tr>
                                      <td>{user.gameType}</td>
                                      <td>{user.eventName}</td>
                                      <td>{user.bookA}</td>
                                      <td>{user.nationA}</td>
                                      <td>{user.bookB}</td>
                                      <td>{user.nationB}</td>
                                      <td>{user.bookC}</td>
                                      <td>{user.nationC}</td>
                                      <td>{user.noOrBet}</td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className='col-md-6 m-t-10'>
                            <h4 className='m-b-10 col-md-12'>User Details</h4>
                            <table className='table table-striped table-dark'>
                              <thead>
                                <tr>
                                  <th>UserName</th>
                                  <th>Exposer</th>
                                  <th>Creditref</th>
                                  <th>ExpoLimits</th>
                                  <th>General</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {
                                      userDetails?.accountDataUserDetailsDTO
                                        ?.userName
                                    }
                                  </td>{' '}
                                  <td>
                                    {
                                      userDetails?.accountDataUserDetailsDTO
                                        ?.exposure
                                    }
                                  </td>{' '}
                                  <td>
                                    {
                                      userDetails?.accountDataUserDetailsDTO
                                        ?.creditReference
                                    }
                                  </td>{' '}
                                  <td>
                                    {
                                      userDetails?.accountDataUserDetailsDTO
                                        ?.exposureLimit
                                    }
                                  </td>{' '}
                                  <td>
                                    {
                                      userDetails?.accountDataUserDetailsDTO
                                        ?.balance
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className='col-md-6 m-t-10'>
                            <h4 className='m-b-10 col-md-12'>Fancy Book</h4>
                            <table className='table table-striped table-dark'>
                              <thead>
                                <tr>
                                  <th>EventName</th>
                                  <th>Book</th>
                                </tr>
                              </thead>
                              <tbody>
                                {userDetails?.fancyBookUserDetailsDTOS?.map(
                                  (user) => (
                                    <tr>
                                      <td>{user.eventName}</td>
                                      <td>{user.book}</td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
            </ModalContent>
          </Modal>
          <div class='header-right-section'>
              <ul class='user-search list-unstyled'>
                <li class='search'>
                  <AsyncSelect
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: 'none',
                        boxShadow: 'none',
                        height: '30px',
                        width: '150px',
                      }),
                      input: (base) => ({
                        ...base,
                        height: '30px',
                        width: '150px',
                      }),
                      indicatorSeparator: (base) => ({
                        ...base,
                        display: 'none',
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        display: 'none',
                      }),
                      menu: (base) => ({
                        ...base,
                        width: '150px',
                        overflow: 'hidden',
                        color: 'black',
                      }),
                    }}
                    cacheOptions
                    defaultOptions
                    loadOptions={searchClient}
                    onChange={(e) => getUserDetail(e.value)}
                    type='text'
                    name='search-account_details'
                    id='search-account_details'
                    placeholder='All Client'
                    class='ui-autocomplete-input'
                    autocomplete='off'
                  />
                </li>
                <li class='username btco-hover-menu' ref={dropdownRef}>
                  <span onClick={() => setDropdownOpen((prev) => !prev)} style={{ cursor: 'pointer' }}>
                    {userName} <ChevronDownIcon />
                  </span>
                  <ul className={dropdownOpen ? 'open' : ''}>
                    <li>
                      <a href='/admin/change-password' class='dropdown-item'>
                        Change password
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          dispatch({
                            type: 'accountData/logOut',
                            payload: {},
                          });
                          window.localStorage.clear();
                          window.location.href = '/';
                        }}
                        class='dropdown-item'
                        href
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </header>
  );
}
{
  /*    <header>
      <Box className="header_wrapper">
        <Container className="container_fluid">
          <a className="logo">
            <img src={require("../assets/img/logo.png")} />
          </a>
          <button
            className="side_menu_button"
            onClick={onOpen}
            bg="$themeColor"
            ref={drawerButtonRef}
          >
            <HamburgerIcon />
          </button>
          <div className="navbar">
            <Link to="/admin/manage-client/list">
              <Button
                bg="$themeColor"
                _hover={{ bg: "#0f0f0f" }}
                _active={{ bg: "#0f0f0f" }}
              >
                <Text fontSize="14px">List of Clients</Text>
              </Button>
            </Link>
            <Button
              bg="$themeColor"
              _hover={{ bg: "#0f0f0f" }}
              _active={{ bg: "#0f0f0f" }}
            >
              <Text fontSize="14px">Market Analysis</Text>
            </Button>
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="Options"
                variant="solid"
                bg="$themeColor"
                p="10px"
                _hover={{ bg: "#0f0f0f" }}
                _active={{ bg: "#0f0f0f" }}
              >
                <Text fontSize="14px">Live Market</Text>
              </MenuButton>
              <MenuList bg="$themeColor">
                <MenuItem icon={<AddIcon />} command="⌘T">
                  New Tab
                </MenuItem>
                <MenuItem icon={<ExternalLinkIcon />} command="⌘N">
                  New Window
                </MenuItem>
                <MenuItem icon={<RepeatIcon />} command="⌘⇧N">
                  Open Closed Tab
                </MenuItem>
                <MenuItem icon={<EditIcon />} command="⌘O">
                  Open File...
                </MenuItem>
              </MenuList>
            </Menu>
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="Options"
                variant="solid"
                bg="$themeColor"
                p="10px"
                _hover={{ bg: "#0f0f0f" }}
                _active={{ bg: "#0f0f0f" }}
              >
                <Text fontSize="14px">Reports</Text>
              </MenuButton>
              <MenuList bg="$themeColor">
                <MenuItem icon={<AddIcon />} command="⌘T">
                  New Tab
                </MenuItem>
                <MenuItem icon={<ExternalLinkIcon />} command="⌘N">
                  New Window
                </MenuItem>
                <MenuItem icon={<RepeatIcon />} command="⌘⇧N">
                  Open Closed Tab
                </MenuItem>
                <MenuItem icon={<EditIcon />} command="⌘O">
                  Open File...
                </MenuItem>
              </MenuList>
            </Menu>
          </div>
        </Container>
        <Menu>
          <MenuButton
            bg="#0088ccE6"
            as={Button}
            rightIcon={<ChevronDownIcon />}
          >
            {userName}
          </MenuButton>
          <MenuList bg="#0088ccE6">
            <MenuItem bg="#0088ccE6">Change Password</MenuItem>
            <MenuItem
              onClick={() => {
                dispatch({
                  type: "accountData/logOut",
                  payload: {},
                });
                window.localStorage.clear();
                window.location.href = "/";
              }}
              bg="#0088ccE6"
            >
              Log Out
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </header>  */
}
